@layer design-system {
  .svgChart {
    width: 100%;
    height: 56px;
    border-radius: 3px;
  }

  .svgBounds {
    width: 100%;
    height: 16px;
  }

  .overlayWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
  }

  .rectBackground {
    fill: var(--surface-default);
    width: inherit;
    height: 100%;
  }

  .pathPlot {
    stroke-width: 1;
    fill: none;
    stroke: var(--surface-inverse);
  }

  .lineXAxis {
    stroke: var(--icon-disabled);
    stroke-width: 1;
  }

  .zeroLine {
    stroke: var(--icon-disabled);
    stroke-width: 1;
    stroke-dasharray: 1 1;
  }
}
